import React from "react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./navbar.css";
import { useHistory } from 'react-router-dom';
import jsCookie from 'js-cookie';
function Navbar() {
    const history = useHistory();
  const [navbar, setNavbar] = useState(false);
  let json = localStorage.getItem("identifier");
  let username = JSON.parse(json);


const handleLogout = () => {

    // Clear storage
    sessionStorage.clear();
    localStorage.clear();
     
    // Remove cookie 
    jsCookie.remove('loggedIn');
  // Delete all cookies
  document.cookie.split(";").forEach(function(c) { 
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
    // Redirect 
    history.push('/signin');
     
    // Reload  
    window.location.reload();
  }

  return (
    <nav className="w-full text-white bg-gray-500 shadow">

      <div className="justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
        <div>
          <div className="flex items-center justify-between py-3 md:py-5 md:block">
            <Link to="/faq">
              <h2 className="text-2xl font-bold text-white">CBE</h2>
            </Link>
            <div className="md:hidden">
              <button
                className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                onClick={() => setNavbar(!navbar)}
              >
                {navbar ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
        <div>
          <div
            className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
              navbar ? "block" : "hidden"
            }`}
          >
            <ul className="items-center justify-center space-y-8 md:flex md:space-x-6 md:space-y-0">
              <li className="text-white hover:text-gray-300">
                <NavLink activeClassName="active" to="/listArchive">
                  Archive
                </NavLink>
              </li>
              <li className="text-white hover:text-gray-300">
                <NavLink activeClassName="active" to="/category">
                  Category
                </NavLink>
              </li>
              <li className="text-white hover:text-gray-200">
                <NavLink activeClassName="active" to="/about">
                  About US
                </NavLink>
              </li>
              <li className="text-white hover:text-gray-200">
                <NavLink activeClassName="active" to="/contact">
                  Contact US
                </NavLink>
              </li>
              <li className="text-white hover:text-gray-200">
                <NavLink activeClassName="active" to="/faq">
                  FAQ
                </NavLink>
              </li>
              <li className="text-white hover:text-gray-200">
                <NavLink
                  onClick={handleLogout}
                  activeClassName="active"
                  to="/signin"
                >
                  logout
                </NavLink>
              </li>
              <li className="text-white hover:text-gray-200">{username}</li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
